import { put, takeEvery } from 'redux-saga/effects'
import { GITCARD_DISPLAYAREAS_LOADING, GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS, GET_GITCARD_DISPLAYAREAS_DATA_ERROR } from "../actions/actionGiftCardDisplayAreas";
import { apiDisplayAreas } from 'api';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok) {
        return await response.json();
    }
    else if (response.statusText === 'Unauthorized') {
        throw new Error("Authorization has been denied for this request.");
    }
    else {
        throw new Error("Unable to Get Gift Card Display Areas, response: " + response.statusText + " - " + response.status)
    }
}

function* fetchGiftCardDisplayAreasData(action) {
    try {
        const data = yield fetchAsync(apiDisplayAreas, "giftcard")
        yield put({ type: GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: GET_GITCARD_DISPLAYAREAS_DATA_ERROR, error: e.message });
    }
}

export const sagaGiftcarddisplayAreas = [
    takeEvery(GITCARD_DISPLAYAREAS_LOADING, fetchGiftCardDisplayAreasData)
];
